// t7-1b (T4, T6): LA FECHA DE CADUCIDAD DE UNA CARD, en un solo sitio.
//
// El profe elige un DIA en el `input type="date"` de su navegador; se manda el
// INICIO (00:00) de ese dia en la zona del navegador, con su desfase, y el
// servidor exige que ese dia sea posterior a hoy en esa zona (Anexo A 4). Se
// muestra en el idioma activo y en la zona del navegador de quien mira:
// "26 de septiembre" / "September 26", con anio solo si no es el anio en curso.
//
// Sin dependencias: ni i18n ni `lib/api`. El idioma lo pasa quien llama.

function dosDigitos(n) {
  return String(n).padStart(2, '0');
}

function aFecha(valor) {
  if (!valor) return null;
  const d = valor instanceof Date ? valor : new Date(valor);
  return Number.isNaN(d.getTime()) ? null : d;
}

function locale(idioma) {
  return String(idioma || '').toLowerCase().startsWith('es') ? 'es' : 'en';
}

export function formatearFechaDeCaducidad(iso, idioma, ahora = new Date()) {
  const d = aFecha(iso);
  if (!d) return '';
  const opciones = { day: 'numeric', month: 'long' };
  if (d.getFullYear() !== ahora.getFullYear()) opciones.year = 'numeric';
  return new Intl.DateTimeFormat(locale(idioma), opciones).format(d);
}

// t7-3 remate 5 (A3): EL DIA DE CADUCIDAD QUE ELIGIO EL PROFE ('AAAA-MM-DD', del servidor: la fecha de `caduca`
// en la zona de la PUBLICACION) -> "7 de octubre" / "October 7", con anio si no es el anio en curso. Se formatea
// el mediodia de ese dia EN UTC: ninguna cuenta de zona, el mismo texto en cualquier navegador.
export function formatearDiaDeCaducidad(dia, idioma, ahora = new Date()) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dia || ''));
  if (!m) return '';
  const fecha = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 12, 0, 0));
  if (Number.isNaN(fecha.getTime())) return '';
  const opciones = { day: 'numeric', month: 'long', timeZone: 'UTC' };
  if (Number(m[1]) !== ahora.getFullYear()) opciones.year = 'numeric';
  return new Intl.DateTimeFormat(locale(idioma), opciones).format(fecha);
}

// t7-3 remate 5 (A3): la fecha de una card: el dia del servidor (`caduca_dia`) si llega; si no (una respuesta
// guardada vieja), como siempre, con la zona del navegador.
export function fechaDeCaducidadDe(card, idioma, ahora = new Date()) {
  if (card && card.caduca_dia) return formatearDiaDeCaducidad(card.caduca_dia, idioma, ahora);
  return formatearFechaDeCaducidad(card && card.caduca, idioma, ahora);
}

// t7-3 remate 5 (A3): el valor con que abre el calendario de "Cambiar fecha": el dia que eligio el profe (antes, la
// fecha de `caduca` en el navegador, un dia antes si el navegador esta al oeste de la publicacion).
export function valorDelCalendario(card) {
  return (card && card.caduca_dia) || valorDeFechaLocal(card && card.caduca);
}

// Un instante escrito con su hora LOCAL y su desfase: '2026-09-26T00:00:00-06:00'.
// Se escribe la hora que de verdad tiene el instante, no un 00:00 fijo: donde el horario
// de verano empieza a la medianoche (Chile, Paraguay, Cuba) las 00:00 no existen y el
// inicio del dia es la 01:00; un 00:00 con el desfase nuevo seria una hora ANTES, el dia
// anterior (lo encontro la revision adversarial de T4 y T6).
export function isoLocalDe(d) {
  const desfase = -d.getTimezoneOffset();
  const signo = desfase >= 0 ? '+' : '-';
  const abs = Math.abs(desfase);
  return `${d.getFullYear()}-${dosDigitos(d.getMonth() + 1)}-${dosDigitos(d.getDate())}` +
    `T${dosDigitos(d.getHours())}:${dosDigitos(d.getMinutes())}:${dosDigitos(d.getSeconds())}` +
    `${signo}${dosDigitos(Math.floor(abs / 60))}:${dosDigitos(abs % 60)}`;
}

// 'AAAA-MM-DD' (el valor del input) -> el inicio de ese dia en la zona del navegador,
// '2026-09-26T00:00:00-06:00'; null si no vale.
export function inicioDelDiaLocalISO(valor) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(valor || ''));
  if (!m) return null;
  const anio = Number(m[1]);
  const mes = Number(m[2]);
  const dia = Number(m[3]);
  const d = new Date(anio, mes - 1, dia, 0, 0, 0, 0);
  if (d.getFullYear() !== anio || d.getMonth() !== mes - 1 || d.getDate() !== dia) return null;
  return isoLocalDe(d);
}

// El ISO guardado -> 'AAAA-MM-DD' en la zona del navegador (para prellenar el input).
export function valorDeFechaLocal(iso) {
  const d = aFecha(iso);
  if (!d) return '';
  return `${d.getFullYear()}-${dosDigitos(d.getMonth() + 1)}-${dosDigitos(d.getDate())}`;
}

// El `min` del input: manana en la zona del navegador.
export function mananaLocal(ahora = new Date()) {
  const d = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate() + 1);
  return `${d.getFullYear()}-${dosDigitos(d.getMonth() + 1)}-${dosDigitos(d.getDate())}`;
}

export function zonaDelNavegador() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch (e) {
    return '';
  }
}
